module.exports = __webpack_public_path__ + "img/loading.2e90177.gif";